import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useFirebaseAuth } from "./AuthContext";
import LoaderInline from "../components/LoaderInline";
import * as Sentry from "@sentry/react";

const ProtectedRoute = () => {
  const { user, ready, idToken } = useFirebaseAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoaderInline text="Checking authentication..." />
      </div>
    );
  }

  if (!user || !idToken) {
    Sentry.captureMessage("No user or token, redirecting to login", {
      level: "error",
    });
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;